<template>
    <!-- <div class="section-bg">
        <div class="header-title">
            <div class="logo-image">
                <img src="/images/jtca_logo_horizontal.png" alt="ロゴ">
            </div>
            <h1>
                家族ケア専門士認定登録<br/>
                申し込み確認
            </h1>
        </div>
    </div> -->
    <div class="h-[220px] md:h-[300px] bg-[#fff4f0] flex items-center justify-center relative">
        <div>
            <img class="h-24 md:mr-10 mr-4" src="/images/jtca_logo.png" alt="JTCA" />
        </div>
        <h1 class="relative text-left text-2xl md:text-3xl font-bold leading-relaxed md:leading-relaxed">
            家族ケア専門士<br />
            認定登録申し込みフォーム
        </h1>
    </div>
</template>

<script>
export default {
    name: "ConfirmHeader"
}
</script>

<style scoped>

</style>
